import moment from "moment";
import * as React from "react";
import { Currency } from "../../../components/core/05-atoms/CurrencyDisplay";
import { CurrencyInput } from "../../../components/core/05-atoms/CurrencyInput";
import { DateInput } from "../../../components/core/05-atoms/DateInput";
import { asThemeConsumer } from "../../../theme/Theme";
import { joinClasses } from "../../../utils/Filters";
import { formatLicensePlate, isValidLicensePlate } from "../../../utils/LicensePlate";
import { ensure } from "../../../utils/Optional";
import { LicensePlateInput } from "./LicenseplateInput";
export var inputValue = function (value, type, asSummary) {
    if ((type === "date" && !!asSummary) &&
        !!value && typeof value === "string") {
        var isMomentDate = moment(value, "YYYY-MM-DD");
        if (isMomentDate.isValid()) {
            var xyz = isMomentDate.format("DD-MM-YYYY");
            return xyz;
        }
        else {
            return "";
        }
    }
    if (type === "licensePlate" && !!asSummary) {
        var v = value === "NULL" || !value ? "" : value === null || value === void 0 ? void 0 : value.toString();
        return isValidLicensePlate(v)
            ? formatLicensePlate(v)
            : v === null || v === void 0 ? void 0 : v.toUpperCase();
    }
    return value || value === 0 ? value : "";
};
/**
 *
 * @param props
 */
var InputComp = function (props) {
    var clazzName = joinClasses(props.className, "scl-a-input__field", props.asSummary ? "scl-a-input__field--as-summary" : "");
    var onChange = !!props.onChange
        ? function (evt) {
            evt.preventDefault();
            ensure(props.onChange)(evt.target.value || undefined);
        }
        : undefined;
    return (props.type === "currency" ? (!!props.asSummary ? (React.createElement(Currency, { className: clazzName, amount: props.value })) :
        (React.createElement(CurrencyInput, { className: clazzName, amount: props.value, onChange: props.onChange, isInput: true, placeholder: props.placeholder, disabled: !!props.disabled, withPrefix: props.withPrefix, withoutDecimal: props.withoutDecimal })))
        : props.type === "date" && !props.asSummary ?
            (React.createElement(DateInput, { onChange: props.onChange, className: clazzName, value: props.value, popperPlacement: props.popperPlacement, minDate: props.minDate, maxDate: props.maxDate, disabled: !!props.disabled, required: props.required }))
            : (props.type === "licensePlate" && !props.asSummary) ?
                (React.createElement(LicensePlateInput, { value: inputValue(props.value, props.type, props.asSummary), onChange: props.onChange, disabled: !!props.disabled, required: props.required, asSummary: props.asSummary }))
                : (React.createElement("input", { type: props.type && !props.asSummary ? props.type : "text", className: clazzName, placeholder: props.placeholder, readOnly: !onChange, value: inputValue(props.value, props.type, props.asSummary), onChange: onChange, disabled: !!props.disabled, min: props.min, max: props.max, required: props.required, title: props.title })));
};
/**
 *
 */
export var Input = asThemeConsumer(InputComp);
